

























import Vue, { PropType } from 'vue';
import {
  genDownloadImageUrl,
  genDownloadImageUrlByImage,
  sizes,
} from '@/modules/image';
import {
  Brand,
  calender,
  FirestoreDate,
  Booth,
} from 'mostra';

export type DataType = {
  brandName: string;
  brandLogo: string | null;
  kvImage: string | null;
  exhibitorStartDate: string;
  exhibitorStartDay: string;
  exhibitorEndDate: string;
  exhibitorEndDay: string;
  boothStartDate: string;
  boothStartDay: string;
  boothEndDate: string;
  boothEndDay: string;
  siteStartDate: string;
  siteStartDay: string;
  siteEndDate: string;
  siteEndDay: string;
  // loading: boolean;
};

export default Vue.extend({
  name: 'GBoothCard',
  props: {
    owner: { type: String as PropType<string>, required: true },
    booth: { type: Object as PropType<Booth>, required: true },
    isAvailable: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    exhibitionName: { type: String as PropType<string>, default: '' },
    exhibitorStartTerm: { type: Object as PropType<FirestoreDate>, default: null },
    exhibitorEndTerm: { type: Object as PropType<FirestoreDate>, default: null },
    boothName: { type: String as PropType<string>, required: true },
    boothStartTerm: { type: Object as PropType<FirestoreDate>, default: null },
    boothEndTerm: { type: Object as PropType<FirestoreDate>, default: null },
    siteStartTerm: { type: Object as PropType<FirestoreDate>, default: null },
    siteEndTerm: { type: Object as PropType<FirestoreDate>, default: null },
    brands: { type: Array as PropType<Brand[]>, default: () => ([]) },
    brandId: { type: String as PropType<string>, default: '' },
    kvImageId: { type: String as PropType<string>, default: '' },
  },
  // computed: {
  //   hasClickEdit(): boolean {
  //     return typeof this.onClickEdit === 'function';
  //   },
  // },
  data(): DataType {
    return {
      brandName: '',
      brandLogo: null,
      kvImage: null,
      exhibitorStartDate: calender.formatDate(this.exhibitorStartTerm),
      exhibitorStartDay: calender.formatDay(this.exhibitorStartTerm),
      exhibitorEndDate: calender.formatDate(this.exhibitorEndTerm),
      exhibitorEndDay: calender.formatDay(this.exhibitorEndTerm),
      boothStartDate: calender.formatDate(this.boothStartTerm),
      boothStartDay: calender.formatDay(this.boothStartTerm),
      boothEndDate: calender.formatDate(this.boothEndTerm),
      boothEndDay: calender.formatDay(this.boothEndTerm),
      siteStartDate: calender.formatDate(this.siteStartTerm),
      siteStartDay: calender.formatDay(this.siteStartTerm),
      siteEndDate: calender.formatDate(this.siteEndTerm),
      siteEndDay: calender.formatDay(this.siteEndTerm),
      // loading: false,
    };
  },
  methods: {
    async setBrandData() {
      const boothBrand = this.brands.find((brand) => brand.id === this.brandId);
      if (boothBrand) {
        this.brandName = boothBrand.data.base.name;
        this.brandLogo = await genDownloadImageUrlByImage(
          sizes.x128,
          boothBrand.data.base.logo,
        );
      }
    },
    async setKvImage() {
      this.kvImage = await genDownloadImageUrl(
        sizes.x512,
        this.kvImageId,
      );
    },
    clickCard() {
      // this.$emit('onClickEdit', this.booth.id);
      this.$router.push({
        name: 'exhibitor-booth-edit',
        query: {
          id: this.booth.id,
          page: 'preview',
        },
      });
    },
  },
  async mounted() {
    try {
      await this.setBrandData();
      await this.setKvImage();
    } catch (error: any) {
      console.log(error);
    }
  },
});
